<div>
    <div class="bg-cover bg-no-repeat bg-bottom py-6 px-3 md:px-6 relative"
         style="background: url(assets/layout/images/landing/landing-main.jpg)">
        <div style="background: linear-gradient(0deg, var(--gray-900), var(--gray-900)); opacity: .6; top: 0; left: 0; "
             class="w-full h-full absolute z-0"></div>
        <div class="absolute" style="top: 0; right: 0;">
            <p-selectButton [options]="languages"
                            [(ngModel)]="languageId"
                            optionValue="id"
                            (onChange)="changeLanguage($event)">
                <ng-template let-item pTemplate>
                    <img [src]="item.flag" alt="image" />
                </ng-template>
            </p-selectButton>
        </div>
        <div class="my-0 mx-auto w-full z-2 relative" style="max-width: 1200px">
            <div class="flex flex-column gap-5 lg:flex-row justify-content-between">
                <div class="flex justify-content-center lg:justify-content-start align-items-center gap-4">
                </div>
                <div class="flex justify-content-center lg:justify-content-end align-items-center gap-3">
                    <a *ngIf="!isLoggedIn" class="p-component p-button w-10rem p-button-outlined text-white hover:text-gray-700 transition-duration-200 hover:bg-white"
                       queryParamsHandling="merge" [routerLink]="['/login']">
                        <span class="p-button-label">{{T.translate('pages.welcome.login')}}</span>
                    </a>
                    <button *ngIf="isLoggedIn" pButton pRipple [label]="T.translate('pages.welcome.logout')" (click)="logout()"
                            class="w-10rem p-button-outlined text-white hover:text-gray-700 transition-duration-200 hover:bg-white"></button>
                    <a *ngIf="isLoggedIn" class="p-component p-button w-10rem p-button-outlined text-white hover:text-gray-700 transition-duration-200 hover:bg-white"
                       queryParamsHandling="merge" [routerLink]="['/dashboard']">
                        <span class="p-button-label">{{T.translate('pages.welcome.dashboard')}}</span>
                    </a>

                </div>
            </div>

            <div class="flex align-items-center justify-content-center py-5" style="background-color: transparent;">
                <img src="assets/layout/images/sinetos-logo.png" style="height: 140px;background-color: #ffffff80;" />
            </div>
        </div>
    </div>

    <div class="flex align-items-center justify-content-center py-5" style="background-color: white;">
        <img src="assets/layout/images/sinetos-logo.png" />
    </div>
</div>
